import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface HarborCapabilitiesState {
  uniqueKeys: string[] | null;
}

const initialState: HarborCapabilitiesState = {
  uniqueKeys: null,
};

const harborCapabilitiesSlice = createSlice({
  name: "harborCapabilities",
  initialState,
  reducers: {
    setHarborCapabilities: (
      state,
      action: PayloadAction<{ capabilities?: string[] }>,
    ) => {
      state.uniqueKeys = action.payload.capabilities ?? null;
    },
    clearHarborCapabilities: (state) => {
      state.uniqueKeys = null;
    },
  },
});

export const { setHarborCapabilities, clearHarborCapabilities } =
  harborCapabilitiesSlice.actions;
export default harborCapabilitiesSlice.reducer;

export const selectHarborCapabilities = (state: RootState) =>
  state.harborCapabilities.uniqueKeys;
